// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"f1eac18d","981":"a0ff079d"}[chunkId] + ".chunk.js";
};